import './App.css';
import Header from "./blocks/header";
import Dashboard from "./blocks/dashboard";
import * as React from "react";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import Copyright from "./blocks/copyright";
import DomainIcon from '@mui/icons-material/Domain';
import BusinessIcon from '@mui/icons-material/Business';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import FilePresentIcon from '@mui/icons-material/FilePresent';
import SummarizeIcon from '@mui/icons-material/Summarize';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import ArticleIcon from '@mui/icons-material/Article';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import InventoryIcon from '@mui/icons-material/Inventory';
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {connect} from "react-redux";
import {getAllVerifyResponse, getUserInfo} from "./store/logIn";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";

const SECTIONS = [
    {type: 'biznes_reja',        labelKey: 'section_biznes_reja',        Icon: ArticleIcon},
    {type: 'kuzgi_qishki',       labelKey: 'section_kuzgi_qishki',       Icon: AcUnitIcon},
    {type: 'mehnat_muhofazasi',  labelKey: 'section_mehnat_muhofazasi',  Icon: HealthAndSafetyIcon},
    {type: 'yongin_xavfsizligi', labelKey: 'section_yongin_xavfsizligi', Icon: WhatshotIcon},
    {type: 'inventarizatsiya',   labelKey: 'section_inventarizatsiya',   Icon: InventoryIcon},
]

function Card({to, Icon, label, color}) {
    return (
        <div className="col-lg-3">
            <Link to={to}>
                <div className="card">
                    <div className="card-header">
                        <Icon className={'icon-card'} style={color ? {fill: color} : {}}/>
                    </div>
                    <div className="card-body">
                        <h3 className={'text-center mb-0 text-uppercase'}>{label}</h3>
                    </div>
                </div>
            </Link>
        </div>
    )
}

function App(props) {
    const {t} = useTranslation()

    const [is_main, setIsMain] = useState(() => {
        const s = localStorage.getItem('is_main')
        return s !== null ? JSON.parse(s) : null
    })

    useEffect(() => { props.getUserInfo() }, [])

    useEffect(() => {
        const u = props.user
        if (!u || u.is_main === undefined) return
        setIsMain(u.is_main)
        localStorage.setItem('is_main', JSON.stringify(u.is_main))
        if (u.is_other !== undefined) {
            localStorage.setItem('is_other', JSON.stringify(u.is_other))
        }
        if (u.display_name !== undefined) {
            localStorage.setItem('user_name', JSON.stringify(u.display_name || ''))
        }
    }, [props.user])

    if (is_main === null) {
        return (
            <div className="App">
                <div className={'home page'}>
                    <Header/><Dashboard/>
                    <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                        <Toolbar/>
                        <div className={'main'} style={{textAlign: 'center', padding: '40px'}}>
                            Yuklanmoqda...
                        </div>
                    </Box>
                </div>
            </div>
        )
    }

    return (
        <div className="App">
            <div className={'home page'}>
                <Header/><Dashboard/>
                <Box component="main" sx={{flexGrow: 1, height: '100vh', overflow: 'auto'}}>
                    <Toolbar/>
                    <div className={'main'}>
                        {is_main ? (
                            /* ── ADMIN (Markaziy bo'lim): 2 ta tugma ── */
                            <div className="row">
                                <Card to="/main/"         Icon={DomainIcon}   label={t('main')}/>
                                <Card to="/all-branches/" Icon={BusinessIcon}  label={t('tashkilotlar')}/>
                            </div>
                        ) : (
                            /* ── TASHKILOT ── */
                            <div className="row">
                                <Card to="/documents/" Icon={FilePresentIcon}  label={t('required_documents')}/>
                                <Card to="/problems/"  Icon={SyncProblemIcon}  label={t('problems')}/>
                                <Card to="/workers/"   Icon={FolderSharedIcon} label={t('workers')}/>
                                <Card to="/reports/"   Icon={SummarizeIcon}    label={t('reports')}/>
                                <Card to="/mahsulotlar/" Icon={ShoppingBagIcon} label={t('mahsulotlar')}/>
                                {SECTIONS.map(({type, labelKey, Icon}) => (
                                    <Card key={type} to={`/sections/${type}/`} Icon={Icon} label={t(labelKey)}/>
                                ))}
                            </div>
                        )}
                    </div>
                    <Copyright/>
                </Box>
            </div>
        </div>
    );
}

export default connect(props => props.login, {getAllVerifyResponse, getUserInfo})(App);
